// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"892ba851","134":"ccf7a345","181":"c51b98ca","191":"420394be","423":"f301002b","488":"e3079838","649":"4c0cba51","842":"8ab4989f"}[chunkId] + ".chunk.js";
};